export default [
  {
    title: '天数',
    key: 'dayNum'
  },
  {
    title: '中间件游戏',
    key: 'mGameName'
  },
  {
    title: '安卓合格标准',
    key: 'androidStandard'
  },
  {
    title: 'iOS合格标准',
    key: 'iosStandard'
  },
  {
    title: '创建时间',
    key: 'createTime'
  },
  {
    title: '更新时间',
    key: 'upTime'
  },
  {
    title: '操作',
    key: 'control'
  }
]
